export const RECOGNISED_INPUT_ID_KW = "recognisedInputId"

export const ATTACHMENT_INPUT_01_GENERAL = "ATTCH INPUT 01 GENERAL"
export const ATTACHMENT_INPUT_01_IMAGES = "ATTCH INPUT 01 IMAGES" // Cutouts
export const SELECT_DEVICE_RECOGNISED_FORM_01 =
    "SELECT DEVICE RECOGNISED FORM 01"
export const SELECT_EXISTING_DEVICE_RECOGNISED_FORM_01 =
    "SELECT EXISTING DEVICE RECOGNISED FORM 01"

export const ATTACHMENT_FORM_TYPES = [
    ATTACHMENT_INPUT_01_GENERAL,
    ATTACHMENT_INPUT_01_IMAGES,
]
